/**
 * Rotating placeholder hints for agent run workspace composer (planning chat pattern).
 */
export const RUN_WORKSPACE_INPUT_EXAMPLE_PROMPTS: readonly string[] = [
  'What should I upload or configure to get started?',
  'Summarize the current working set and what is missing.',
  'What are the top gaps or opportunities in this run?',
  'Walk me through the next useful step for this agent.',
  'What assumptions should I confirm before we proceed?',
  'Show me what changed since my last conversation.',
];

export const RUN_WORKSPACE_HINT_STEP_MS = 2200;
